import { z } from '../zod';
import { ObjectIdStringValidationSchema } from '../shared/ObjectId';
import { TicketGroupResponseValidationSchema } from '../event-page/response';

export const TicketGroupDetailResponseValidationSchema = TicketGroupResponseValidationSchema.omit({
  ticketTypes: true,
})
  .extend({
    ticketTypeIds: z.array(ObjectIdStringValidationSchema),
  })
  .openapi('TicketGroupDetail');

export const TicketGroupListResponseValidationSchema = z
  .object({
    data: z.array(TicketGroupDetailResponseValidationSchema),
  })
  .openapi('TicketGroupListResponse');

export const TicketGroupEnvelopeResponseValidationSchema = z
  .object({
    data: TicketGroupDetailResponseValidationSchema,
  })
  .openapi('TicketGroupEnvelopeResponse');
